import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';
import { Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const { t } = useI18n();
  const { user, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try { await login(email, password); navigate('/admin'); }
    catch (e) { setErr(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : t('admin.invalid_credentials')); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24 lg:py-32" data-testid="admin-login-page">
      <p className="gn-overline mb-4 text-center">{t('admin.title')}</p>
      <h1 className="font-serif text-4xl text-center text-[#f5f5f0] mb-12">{t('admin.login')}</h1>
      <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
        <div>
          <label className="gn-overline mb-3 block">{t('admin.email')}</label>
          <input required type="email" className="gn-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
        </div>
        <div>
          <label className="gn-overline mb-3 block">{t('admin.password')}</label>
          <input required type="password" className="gn-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
        </div>
        {err && <p className="text-sm text-[#9c4b4b]" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={loading} className="gn-btn-primary w-full" data-testid="admin-login-submit">
          {loading && <Loader2 className="animate-spin" size={16} />}
          {t('admin.login')}
        </button>
      </form>
    </div>
  );
}
